import React from 'react';

import Header from './Header';
import CircleDiagram from './CircleDiagram';

const SCORE_COLORS = {
	low: '#da1a33',
	medium: '#fbd941',
	high: '#00a14a',
};

const DEFAULT_COLOR = '#da1a33';

const getScoreColor = (icon) => SCORE_COLORS[icon] || DEFAULT_COLOR;

const ResultsSummary = ({ disciplineOne, disciplineTwo, disciplineThree, disciplineFour }) => {
	const colors = {
		q1: disciplineOne.icon,
		q2: disciplineTwo.icon,
		q3: disciplineThree.icon,
		q4: disciplineFour.icon,
	};

	return (
		<div className={'ohs-summary'}>
			<Header />

			<div className={'ohs-summary__content ohs-content-padding'}>
				<div className={'ohs-summary__scores-container'}>
					<div className={'ohs-summary__score ohs-summary__score--top-left'}>
						<div className={'ohs-summary__score-label'}>Your Score:</div>
						<div className={'ohs-summary__score-value'}>{disciplineOne.score}</div>
						<div className={'ohs-summary__score-line ohs-summary__score-line--right'} style={{ backgroundColor: getScoreColor(disciplineOne.icon), transform: 'rotate(30deg)', transformOrigin: 'left center' }} />
					</div>

					<div className={'ohs-summary__score ohs-summary__score--top-right'}>
						<div className={'ohs-summary__score-label'}>Your Score:</div>
						<div className={'ohs-summary__score-value'}>{disciplineTwo.score}</div>
						<div className={'ohs-summary__score-line ohs-summary__score-line--left'} style={{ backgroundColor: getScoreColor(disciplineTwo.icon), transform: 'rotate(-30deg)', transformOrigin: 'right center' }} />
					</div>

					<div className={'ohs-summary__diagram'}>
						<CircleDiagram colors={colors} size={460} textColor={"#000"} />
					</div>

					<div className={'ohs-summary__score ohs-summary__score--bottom-left'}>
						<div className={'ohs-summary__score-line ohs-summary__score-line--right ohs-summary__score-line--top'} style={{ backgroundColor: getScoreColor(disciplineFour.icon), transform: 'rotate(-30deg)', transformOrigin: 'left center' }} />
						<div className={'ohs-summary__score-label'}>Your Score:</div>
						<div className={'ohs-summary__score-value'}>{disciplineFour.score}</div>
					</div>

					<div className={'ohs-summary__score ohs-summary__score--bottom-right'}>
						<div className={'ohs-summary__score-line ohs-summary__score-line--left ohs-summary__score-line--top'} style={{ backgroundColor: getScoreColor(disciplineThree.icon), transform: 'rotate(30deg)', transformOrigin: 'right center' }} />
						<div className={'ohs-summary__score-label'}>Your Score:</div>
						<div className={'ohs-summary__score-value'}>{disciplineThree.score}</div>
					</div>
				</div>

				<div className={'ohs-summary__legend'}>
					<div className={'ohs-summary__legend-item'}>
						<div className={'ohs-summary__legend-color ohs-summary__legend-color--low'} />
						<span className='ohs-summary__legend-color--text'>Low: 1:00 - 2.99</span>
					</div>
					<div className={'ohs-summary__legend-item'}>
						<div className={'ohs-summary__legend-color ohs-summary__legend-color--medium'} />
						<span className='ohs-summary__legend-color--text'>Medium: 3.00 - 3.99</span>
					</div>
					<div className={'ohs-summary__legend-item'}>
						<div className={'ohs-summary__legend-color ohs-summary__legend-color--high'} />
						<span className='ohs-summary__legend-color--text'>High: 4.00 - 5.00</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ResultsSummary;
